import React,{useContext,useEffect, useState, useRef, useMemo} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik, } from 'formik';
import { getRequest, postRequest } from '../../api/ApiController';
import { SaveIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon,DeleteIcon,BotIcon,PaperClipIcon} from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { DateTime } from "luxon";
import { confirmDialog } from 'primereact/confirmdialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Avatar } from 'primereact/avatar';
import MyEditor from '../../components/Editor';
import { Message } from 'primereact/message';
import { OverlayPanel } from 'primereact/overlaypanel';
import parse from 'html-react-parser';
import { MultiSelect } from 'primereact/multiselect';
import { Skeleton } from 'primereact/skeleton';
import { createArrayNavigateHandlers } from '../../utils/arrayNavigate';
import { createAsyncNavigateHandlers } from '../../utils/asyncArrayNavigate';
import { getPusherChannel } from '../../utils/pusherChannel';
import { LocaleContext } from '../../components/LocaleContext';
import { resolveSystemI18nComment } from '../../utils/systemI18nComment';

export default function ChecklistRecordAllDetail({checklist_record=null,recordId=null,type="edit",navigationContext=null,machinesOnly=false}){

    const [state,dispatch] = useContext(DatabaseContext);
    const {openFavoriteDialog,toast,setFastView,setVisible,setDialogText,getUserColor,getUserInitials,formatID,openFilePreview,formatDate}= useContext(UtilContext);
    const {user} = useContext(AuthContext);
    const { t } = useContext(LocaleContext);

    const [formChecklistRecord,setFormChecklistRecord] = useState(checklist_record);
    const [formType, setFormType] = useState(type);

    const [images,setImages] = useState([]);
    const [responseFiles,setResponseFiles] = useState(null);

    const [scrollIcons,setScrollIcons] = useState(true);

    const [closeTab,setCloseTab] = useState(false);

    const submitRef = useRef(null);

    const op = useRef(null);
    const scrollRef = useRef(null);
    const [commentClick,setCommentClick] = useState(false);
    const [updatableComment,setUpdatableComment] = useState(0);
    const [sortDescending, setSortDescending] = useState(true); // true = najnovšie navrchu
    const [showAddUser,setShowAddUser] = useState(false);
    const [addedUser,setAddedUser] = useState([]);

    const resolvedId = recordId ?? checklist_record?.id;
    // Fallback: pri edit s recordId použij minimálny nav context ak chýba (onEditRow, toolbar edit, preview vždy posielajú)
    const effectiveNavContext = navigationContext ?? (formType === "edit" && resolvedId ? { filters: [], sorters: [] } : null);
    const loadedRecordRef = useRef(null);
    const loadedFilesRef = useRef(null);
    const markedViewedRef = useRef(new Set());

    const markAsViewed = async (recordId) => {
        let formData = new FormData();
        formData.append('record_id',recordId);
        formData.append('user_id',user.id);
        postRequest(`/api/checklist_records/${recordId}/mark-as-viewed`, formData,true)
        .then((response) => {
            dispatch({ type: 'updateRecordViewed', payload: recordId });
        }).catch((reason) => {
            dispatch({ type: 'updateRecordViewed', payload: recordId });
        });
    };
    
    // 1) načítaj FULL record iba raz na ID (vrátane StrictMode guard)
    useEffect(() => {
        if (!resolvedId) return;
        if (loadedRecordRef.current === resolvedId) return; // guard
        loadedRecordRef.current = resolvedId;

        let cancelled = false;

        (async () => {
            try {
            const resp = await getRequest(`/api/checklist_records/${resolvedId}`);
            if (cancelled) return;

            const full = { ...resp.data, is_unread: checklist_record?.is_unread };
            setFormChecklistRecord(full);
            } catch (e) {
            console.error(e);
            }
        })();

        return () => { cancelled = true; };
    }, [resolvedId]);

    // 2) načítaj protocols/images iba raz na ID (keď už record existuje)
    useEffect(() => {
        const id = formChecklistRecord?.id;
        if (!id) return;
        if (loadedFilesRef.current === id) return; // guard
        loadedFilesRef.current = id;

        getRecordFiles(id);
        getImages(id);
    }, [formChecklistRecord?.id]);

    // 3) nastav formik recipients/departments (bez files/images a bez duplicity)
    useEffect(() => {
        if (!formChecklistRecord?.user) return;

        const departments = extractDepartmentsFromRecipients([formChecklistRecord.user]);
        formik.setFieldValue("recipients", [formChecklistRecord.user], false);
        formik.setFieldValue("recipientDepartments", departments, false);
    }, [formChecklistRecord?.user?.id]);

    // 4) mark as viewed iba raz na ID (a používaj resolvedId, nie checklist_record.id)
    useEffect(() => {
        const id = resolvedId;
        const unread = formChecklistRecord?.is_unread ?? checklist_record?.is_unread;
        if (!id || !unread) return;
        if (markedViewedRef.current.has(id)) return;
        markedViewedRef.current.add(id);
        markAsViewed(id);
    }, [resolvedId, formChecklistRecord?.is_unread]);

    useEffect(() => {
        // scrollIcons=true = disabled; zapni scroll keď máme effectiveNavContext (z listu alebo fallback)
        setScrollIcons(!effectiveNavContext);
    }, [effectiveNavContext]);

    // Pusher: ak niekto iný upraví/vymaže tento záznam, obnov detail alebo zatvor tab
    useEffect(() => {
        if (!resolvedId) return;
        const channel = getPusherChannel();
        const onUpdated = (data) => {
            const id = data?.id ?? data?.record?.id;
            if (id == null || Number(id) !== Number(resolvedId)) return;
            getRequest(`/api/checklist_records/${resolvedId}`)
                .then((res) => {
                    const d = res?.data ?? res;
                    if (d) setFormChecklistRecord(d);
                })
                .catch(() => {});
        };
        const onDeleted = (data) => {
            if (data?.id !== resolvedId) return;
            dispatch({ type: 'close_tab', id: state.selectedTab });
        };
        channel.bind('checklist_record.updated', onUpdated);
        channel.bind('checklist_record.deleted', onDeleted);
        return () => {
            channel.unbind('checklist_record.updated', onUpdated);
            channel.unbind('checklist_record.deleted', onDeleted);
        };
    }, [resolvedId, dispatch, state.selectedTab]);

    function getRecordFiles(id){
        getRequest(`/api/checklist_records/protocols/${id ? id : formChecklistRecord?.id}`).then((response) => {
            if(response.data!=="{}"){
                setImages(response.data);
                formik?.setFieldValue('files',response.data);
            }
        });
    }

    function getImages(id){
        getRequest(`/api/checklist_records/images/${id ? id : formChecklistRecord?.id}`).then((response) => {
            if(response.data!=="{}"){
                setResponseFiles(response.data);
            }
            else{
                setResponseFiles([]);
            }
        });
    }

    const accept = (id) => {
        getRequest(`/api/checklistRecords/deleteImage/${id}`)
        .then((response) => {
            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.FileDeletedDetail') });
            getImages();
        }).catch((reason) => {
            alert(reason);
            toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.FileDeleteFailedDetail'), life: 3000 });
        })
    };

    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.RequestCancelled'), life: 3000 });
    }
    

    function deleteFiles(img){
        confirmDialog({
            message: t('ServiceTask.DeleteFilePrompt'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept:reject,
            reject:() => accept(img.id)
        });
    }

    const extractDepartmentsFromRecipients = (recipients) => {
        const departmentMap = new Map();

        recipients.forEach((user) => {
            const dept = user?.employee?.department;
            if (dept && !departmentMap.has(dept.id)) {
            departmentMap.set(dept.id, {
                id: dept.id,
                name: dept.name,
                searchLabel: removeDiacritics(dept.name).toLowerCase(),
            });
          }
          else if(user?.employee?.department_id){
            let db_dept = state.departments.find(department => department.id == user?.employee?.department_id);
            departmentMap.set(db_dept.id, {
                id: db_dept.id,
                name: db_dept.name,
                searchLabel: removeDiacritics(db_dept.name).toLowerCase(),
            });
          }
        });

        return Array.from(departmentMap.values());
    };

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    /* form for adding error record */
    const formik = useFormik({
        initialValues: {
            ...formChecklistRecord,
            answers: formChecklistRecord?.answers?.length
                ? formChecklistRecord?.answers
                : formChecklistRecord?.template?.questions?.map(() => ({
                    okNokAnswer: '',
                    okNote: '',
                    nokNote: '',
                    noAnswer: false,
                    noNote: '',
                    photos: [],
                    employeeId: '',
                })) || [],
                save_mode: 'save',
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            setDialogText(t('Common.SavingEllipsis'));
            setVisible(true);
            let formData = new FormData();
            for (let value in values) {
                if(value=="recipientDepartments" || value=="recipients"){
                    formData.append(value, values[value]?.map(obj => obj.id));
                }
                else if(value=="sending_data" || value=="questions"){
                    formData.append(value, JSON.stringify(values[value]));
                }
                else if(value=="manager_id"){
                    formData.append(value, user?.id);
                }
                else{
                    formData.append(value, values[value] != null ? values[value] : "");
                }
            }
            for (const [key, value] of formData.entries()) {
                console.log(`${key}:`, value);
            }
            postRequest(`/api/checklist_records/updateManager/${formik.values.id}`, formData,true)
            .then((response) => {
                const updated = response.data;
                setFormChecklistRecord(updated);
                if (updated) formik.setValues(updated);
                if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                setVisible(false);
                if (updated) window.dispatchEvent(new CustomEvent("checklist_all_records:updated", { detail: updated }));
            }).catch((reason) => {
                setVisible(false);
                alert(t('Common.Toast.ActionFailedDetail'));
            })
        },
    });

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const buildFetchRecord = (toParams = () => '') => async (direction, currentId) => {
            setDialogText(t('Common.Loading'));
            setVisible(true);
            try {
                const q = toParams();
                const machines = machinesOnly ? '&machines_only=1' : '';
                const url = `/api/checklist_all_records/navigate?direction=${direction}${currentId ? '&id=' + currentId : ''}${machines}${q ? '&' + q : ''}`;
                const resp = await getRequest(url);
                return resp?.data ?? null;
            } finally {
                setVisible(false);
            }
        };
        if (effectiveNavContext) {
            const toParams = () => {
                const p = new URLSearchParams();
                (effectiveNavContext.filters || []).forEach(f => {
                    if (f.value != null && String(f.value).trim() !== '') p.set(`filter_${f.field}`, f.value);
                });
                if (effectiveNavContext.sorters?.length) p.set('sorters', JSON.stringify(effectiveNavContext.sorters));
                if (effectiveNavContext.preview != null && effectiveNavContext.preview !== '') p.set('preview', String(effectiveNavContext.preview));
                if (effectiveNavContext.preview_time_from) p.set('preview_time_from', effectiveNavContext.preview_time_from);
                if (effectiveNavContext.preview_time_to) p.set('preview_time_to', effectiveNavContext.preview_time_to);
                return p.toString();
            };
            return createAsyncNavigateHandlers(buildFetchRecord(toParams), setFormChecklistRecord, () => formChecklistRecord?.id ?? resolvedId);
        }
        if (Array.isArray(state.checklist_all_records) && state.checklist_all_records.length > 0) {
            return createArrayNavigateHandlers(state.checklist_all_records, formChecklistRecord?.id ?? formik.values?.id, setFormChecklistRecord);
        }
        return createAsyncNavigateHandlers(buildFetchRecord(), setFormChecklistRecord, () => formChecklistRecord?.id ?? resolvedId);
    }, [effectiveNavContext, state.checklist_all_records, formik.values?.id, formChecklistRecord?.id, resolvedId, machinesOnly, setDialogText, setVisible]);

    function removeDiacritics(str) {
        return (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    const lastAddedComment = useMemo(() => {
        const c = formChecklistRecord?.comments || [];
        if (!c.length) return null;
        return c.reduce((latest, cur) => (cur?.id > latest?.id ? cur : latest), c[0]);
    }, [formChecklistRecord?.comments]);

    var findedIds = [];

    function content(rawDescription) {
        const resolved = resolveSystemI18nComment(rawDescription, t);
        const display = resolved.text ?? '';
        const inner = resolved.type === 'legacy' && String(display).includes('<')
            ? parse(String(display))
            : display;
        return <div className="flex align-items-center">
            <BotIcon/>
            <div className="ml-2">{inner}</div>
        </div>;
    }

    function onlyUnique(value, index, array) {
        return array.indexOf(value) == index;
    }

    function loopThroughDOM(obj) {
        if(Array.isArray(obj)){
            for(let i=0;i<obj.length;i++){
                if(obj[i].hasOwnProperty("props") && obj[i].props.hasOwnProperty("children")){
                    loopThroughDOM(obj[i]["props"]["children"]);
                }
                if(obj[i].hasOwnProperty("props") && obj[i].props.hasOwnProperty("data-value")){
                    findedIds.push(obj[i]["props"]["data-id"]);
                }
            }
        }
        else{
            if(obj.hasOwnProperty("props") && obj.props.hasOwnProperty("children") && obj.props.children!=undefined){
                loopThroughDOM(obj["props"]["children"]);
            }
            if(obj.hasOwnProperty("props") && obj.props.hasOwnProperty("data-value")){
                findedIds.push(obj["props"]["data-id"]);
            }
        }
    }

    const formikComment = useFormik({
        initialValues: {
            description:''
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            setDialogText(t('Common.SavingEllipsis'));
            setVisible(true);
            let formData = new FormData();
            for (let value in values) {
                if(value=="files"){
                    for(let i = 0;i<values[value].length;i++){
                        formData.append('files[]',values[value][i]);
                    }
                }
                else formData.append(value, values[value]);
            }
            formData.append('contractor_id',user.id);
            formData.append('record_id', formChecklistRecord?.id ?? resolvedId);
            let mentions = parse(values.description || "");
            loopThroughDOM(mentions);
            formData.append('mentions', findedIds.filter(onlyUnique));
            postRequest('/api/checklist_comments', formData,true)
            .then((response) => {
                setFormChecklistRecord(response.data);
                getImages(response.data.id);
                if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                formikComment.resetForm();
                setCommentClick(false);
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                setVisible(false);
            }).catch((reason) => {
                setVisible(false);
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            });
        },
    });

    const formikUpdateComment = useFormik({
        initialValues: {
            description:''
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
        setDialogText(t('Common.SavingEllipsis'));
        setVisible(true);
            let formData = new FormData();
            for (let value in values) {
            if(value=="files"){
                for(let i = 0;i<values[value].length;i++){
                    formData.append('files[]',values[value][i]);
                }
            }
            else formData.append(value, values[value]);
            }
            let mentions = parse(values.description || "");
            loopThroughDOM(mentions);
            formData.append('mentions', findedIds.filter(onlyUnique));
            postRequest(`/api/checklist_comments/update/${formikUpdateComment.values.id}`, formData,true)
            .then((response) => {
                setFormChecklistRecord(response.data);
                getImages(response.data.id);
                    if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                    formikUpdateComment.resetForm();
                    setUpdatableComment(false);
                    findedIds = [];
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.CommentUpdated') });
                setVisible(false);
            }).catch((reason) => {
                setVisible(false);
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            });
        },
    });

    function addUser(){
        setDialogText(t('Common.Saving'));
        setVisible(true);
        let formData = new FormData();
        formData.append('mention', addedUser?.map(obj => obj?.id) || '');
        postRequest(`/api/checklist_records/addUser/${formChecklistRecord?.id ?? resolvedId}`, formData,true)
        .then((response) => {
            setFormChecklistRecord(response.data);
            setAddedUser([]);
            setShowAddUser(false);
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.UserAdded')});
                setVisible(false);
        }).catch((reason) => {
            setVisible(false);
            alert(t('Common.Toast.ActionFailedDetail'));
        });
    }

return(
<>
<div>
    <div className='w-full h-10 flex flex-row bg-[#333]'>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button type='submit' className="disabled:opacity-25" onClick={() => {setCloseTab(true);submitRef.current.click();}} disabled={formChecklistRecord?.process_status== 'Rozpracovaný' || user?.id!=(formChecklistRecord ?? checklist_record)?.template?.manager_id || formChecklistRecord?.checklist_status== 'Uzavretý'}><SaveAndCloseIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button type='submit' className="disabled:opacity-25" onClick={() => {submitRef.current.click();}} disabled={formChecklistRecord?.process_status== 'Rozpracovaný' || user?.id!=(formChecklistRecord ?? checklist_record)?.template?.manager_id || formChecklistRecord?.checklist_status== 'Uzavretý'}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => openFavoriteDialog(t('Checklist.RecordTab'),"ChecklistRecordAllDetail")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => setFastView("ChecklistRecordAllDetail")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
        </div>
<div className="relative flex flex-col justify-left overflow-y-auto h-[calc(100vh-177px)]">
    <div className="mb-2 grid grid-cols-2">
      <div className="w-auto p-6 m-4 bg-gray-100">
        <h1 className="text-3xl font-semibold text-left text-zinc-900">Checklist</h1>

        {/* Názov checklistu */}
        <div className="mb-4">
          <label className="block text-md font-semibold text-gray-800">{t('Common.Name')}</label>
          <input
            name="template_name" disabled
            value={formChecklistRecord?.template?.name}
            className="block w-full px-4 py-2 mt-1 bg-gray-200  border rounded-md"
          />
        </div>

        {/* ID */}
        <div className="mb-4">
            <label className="block text-md font-semibold text-gray-800">ID</label>
            <input
                name="name" disabled
                value={formatID("CHL-",3,formChecklistRecord?.id)}
                className="block w-full px-4 py-2 mt-1 bg-gray-200 border rounded-md"
            />
        </div>

        {/* Popis */}
        <div className="mb-4">
            <label className="block text-md font-semibold text-gray-800">{t('Common.Description')}</label>
            <input
                name="name" disabled
                value={formChecklistRecord?.name}
                className="block w-full px-4 py-2 mt-1 bg-gray-200 border rounded-md"
            />
        </div>

        {/* Poznámka zo šablóny */}
        <div className="mb-3">
            <label className="block text-md font-semibold text-gray-800">{t('Common.Note')}</label>
            <InputTextarea
                autoResize
                readOnly
                value={formChecklistRecord?.template?.description}
                className="w-full px-3 py-2 text-sm bg-gray-200 border rounded-md"
            />
        </div>

        <Accordion className='mb-3'>
            <AccordionTab  header="Podrobnosti">
                {/* Intenzita */}
                <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div>
                    <label className="block text-md font-semibold text-gray-800">Intenzita</label>
                    <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                        {(() => {
                        const value = formChecklistRecord?.template?.sending_data;
                        if (!value) return "–";

                        let data;
                        try {
                            data = JSON.parse(value);
                        } catch {
                            return "–";
                        }

                        const intensity = data.intensity || "";
                        const time = data.time || "";

                        const specialDaysMap = {
                            "first_monday": t('ChecklistTemplate.SpecialDay.first_monday'),
                            "first_tuesday": t('ChecklistTemplate.SpecialDay.first_tuesday'),
                            "first_wednesday": t('ChecklistTemplate.SpecialDay.first_wednesday'),
                            "first_thursday": t('ChecklistTemplate.SpecialDay.first_thursday'),
                            "first_friday": t('ChecklistTemplate.SpecialDay.first_friday'),
                            "last_monday": t('ChecklistTemplate.SpecialDay.last_monday'),
                            "last_tuesday": t('ChecklistTemplate.SpecialDay.last_tuesday'),
                            "last_wednesday": t('ChecklistTemplate.SpecialDay.last_wednesday'),
                            "last_thursday": t('ChecklistTemplate.SpecialDay.last_thursday'),
                            "last_friday": t('ChecklistTemplate.SpecialDay.last_friday'),
                        };

                        switch (intensity) {
                            case "denne": return t('Checklist.Intensity.DailyTpl', { time });
                            case "tyzdenne": {
                            const days = data.daysOfWeek || [];
                            return t('Checklist.Intensity.WeeklyTpl', { days: Array.isArray(days) ? days.join(', ') : days, time });
                            }
                            case "mesacne": {
                            if (data.dayMonth) return t('Checklist.Intensity.MonthlySpecialTpl', { day: specialDaysMap[data.dayMonth] || data.dayMonth, time });
                            if (data.daysOfMonth) return t('Checklist.Intensity.MonthlyDayTpl', { day: data.daysOfMonth, time });
                            return t('Checklist.Intensity.MonthlyTimeTpl', { time });
                            }
                            case "rocne": return t('Checklist.Intensity.YearlyTpl', { day: data.day || '', month: data.month || '', time });
                            case "viackrat_den": return t('Checklist.Intensity.MultiDailyTpl', { times: Array.isArray(data.times) ? data.times.join(', ') : data.times });
                            case "nahodne": return t('Checklist.Intensity.Random');
                            default: return intensity || "–";
                        }
                        })()}
                    </div>
                    </div>
                    <div>
                        <label className="block text-md font-semibold text-gray-800">Stroj</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                            {formChecklistRecord?.machine?.name || '–'}
                        </div>
                    </div>
                    </div>

                {/* Oddelenie + Zamestnanec */}
                <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
                {/* Oddelenie */}
                <div>
                    <label className="block text-md font-semibold text-gray-800">{t('Common.Department')}</label>
                    <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                    {formChecklistRecord?.recipientDepartments?.map(departmnent => departmnent?.name)?.join(', ')}
                    </div>
                </div>

                {/* Zodpovedný vedúci */}
                <div>
                <label className="block text-md font-semibold text-gray-800">{t('Checklist.ResponsibleManager')}</label>
                <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                    {(state?.users || [])
                    .filter(user => user?.id == formChecklistRecord?.template?.manager_id)
                    .map(user => user?.employee?.name || user?.username)
                    .join(', ') || '–'}
                </div>
                </div>
                </div>
                
                <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
                    {/* Zamestnanec */}
                    <div>
                        <label className="block text-md font-semibold text-gray-800">Zamestnanec</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                        {(formChecklistRecord?.recipients || [])
                            .map(user => user?.employee?.name || user?.username)
                            .filter(Boolean)
                            .join(', ') || '–'}
                        </div>
                    </div>

                    {/* Dni na vyjadrenie */}
                    <div>
                    <label className="block text-md font-semibold text-gray-800">Dni na vyjadrenie</label>
                    <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                        {formChecklistRecord?.template?.manager_due_days || '–'}
                    </div>
                    </div>
                </div>
            </AccordionTab>
        </Accordion>

        {/* Otázky */}
        <div className="space-y-6">
            <label className="block text-md font-semibold text-gray-800">{t('Ui.R67.Otazky_a_ulohy')}</label>
            {formChecklistRecord?.questions?.map((q, idx) => {
                const modes = typeof q.answer_modes === "string" 
                            ? JSON.parse(q.answer_modes || '{}') 
                            : (q.answer_modes || {});
                const fieldName = `answers[${idx}]`;
                const answer = formChecklistRecord?.answers?.[idx] || {};

                const relevantEmployees = Array.isArray(modes.priorityDepartments) && modes.priorityDepartments.length > 0
                    ? state?.employees?.filter(employee => modes.priorityDepartments.includes(employee?.department_id))
                    : state?.employees;

                return (
                    <div key={idx} className="border rounded-md bg-gray-50 p-4 shadow-sm">
                        {/* Otázka */}
                        <div className="flex items-start gap-3 mb-3">
                            <div className="flex-shrink-0 pt-2 text-md font-semibold text-gray-700">{idx + 1}.</div>
                            <InputTextarea
                            autoResize
                            readOnly
                            placeholder={t('Checklist.QuestionN', { n: idx + 1 })}
                            value={q.text}
                            className="w-full px-3 py-2 text-sm bg-gray-200 border rounded-md"
                            />
                        </div>

                        {/* OK/NOK/NO v jednom riadku */}
                        {(modes.okNok || modes.no) && (
                        <div className="flex gap-6 items-center mb-3">
                            {modes.okNok && (
                                <>
                                <div className="flex items-center gap-2">
                                    <RadioButton
                                    inputId={`ok-${idx}`}
                                    name={`answers.${idx}.okNokAnswer`}
                                    value="ok"
                                    checked={answer.okNokAnswer === 'ok'}
                                    className="custom-radio"
                                    disabled
                                    />
                                    <label htmlFor={`ok-${idx}`} className="text-sm">OK</label>
                                </div>

                                <div className="flex items-center gap-2">
                                    <RadioButton
                                    inputId={`nok-${idx}`}
                                    name={`answers.${idx}.okNokAnswer`}
                                    value="nok"
                                    checked={answer.okNokAnswer === 'nok'}
                                    className="custom-radio"
                                    disabled
                                    />
                                    <label htmlFor={`nok-${idx}`} className="text-sm">NOK</label>
                                </div>
                                </>
                            )}

                            {modes.no && (
                                <div className="flex items-center gap-2">
                                <RadioButton
                                    inputId={`no-${idx}`}
                                    name={`answers.${idx}.okNokAnswer`}
                                    value="no"
                                    checked={answer.okNokAnswer === 'no'}
                                    className="custom-radio"
                                    disabled
                                />
                                <label htmlFor={`no-${idx}`} className="text-sm">NO</label>
                                </div>
                            )}
                        </div>
                        )}

                        {/* Poznámky k OK / NOK / NO */}
                        {Array.isArray(formChecklistRecord?.answers) && modes.okNote && formChecklistRecord?.answers[idx]?.okNokAnswer === 'ok' && (
                            <div className="mb-3">
                                <InputTextarea
                                name={`answers.${idx}.okNote`}
                                value={formChecklistRecord?.answers?.[idx]?.okNote || ''}
                                disabled
                                className="w-full text-sm border rounded-md"
                                placeholder={t('Checklist.NoteOK')}
                                />
                            </div>
                        )}
                        {Array.isArray(formChecklistRecord?.answers) && modes.nokNote && formChecklistRecord?.answers[idx]?.okNokAnswer === 'nok' && (
                            <div className="mb-3">
                                <InputTextarea
                                name={`answers.${idx}.nokNote`}
                                value={formChecklistRecord?.answers?.[idx]?.nokNote || ''}
                                disabled
                                className="w-full mb-3 text-sm border rounded-md"
                                placeholder={t('Checklist.NoteNOK')}
                                />
                            </div>
                        )}
                        {Array.isArray(formChecklistRecord?.answers) && modes.noNote && answer.okNokAnswer === 'no' && (
                        <div className="mb-3">
                            <InputTextarea
                            name={`answers.${idx}.noNote`}
                            value={formChecklistRecord?.answers?.[idx]?.noNote || ''}
                            disabled
                            className="w-full mb-3 text-sm border rounded-md"
                            placeholder={t('Checklist.NoteNO')}
                            />
                        </div>
                        )}

                        {/* Meno zamestnanca + Foto v jednom riadku */}
                        {Array.isArray(formChecklistRecord?.answers) && (modes.name || modes.photo || modes.optional_photo) && (
                            <div className="flex flex-col sm:flex-row gap-4">
                            {(modes.name && answer.okNokAnswer != 'no') && (
                                <div className="flex-1">
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Vyber meno zamestnanca<span className="text-red-500">*</span>
                                </label>
                                <select
                                    name={`${fieldName}.employeeId`}
                                    value={answer.employeeId || ''} disabled
                                    className="w-full border rounded-md px-2 py-1 text-sm"
                                >
                                    <option value="">-- Vyber zamestnanca --</option>
                                    {relevantEmployees.sort((a, b) => a.name.localeCompare(b.name, 'sk', { sensitivity: 'base' })).map(user => (
                                    <option key={user.id} value={user.id}>{user.name}</option>
                                    ))}
                                </select>
                                </div>
                            )}

                            {images?.some(img => img.question_id == idx) && (
                                <div className="mb-4">
                                    <label className="block text-md font-semibold text-gray-800 mb-2">{t('Checklist.Gallery')}</label>
                                    {images.map((img, i) =>  {
                                    if(img?.question_id != idx)return "";
                                    return <table key={i} className="w-full border border-separate border-gray-400 rounded-md bg-white mb-4">
                                        <tbody>
                                        <tr>
                                            <td className="text-black h-10">
                                            <div className="flex flex-row p-2 items-center">
                                                <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })} className="cursor-pointer">
                                                {/\.(pdf|png|jpg|jpeg|gif|webp|bmp|svg|img)$/i.test(img.filename || '') ? (
                                                    <embed src={`${img.url}#view=FitH&scrollbar=0`} width="100px" height="65px" type="application/pdf" />
                                                ) : (
                                                    <div className="w-[100px] h-[65px] flex items-center justify-center bg-gray-100 border rounded"><PaperClipIcon /></div>
                                                )}
                                                </div>
                                                <div className="flex flex-col ml-4">
                                                <a
                                                    style={{ color: 'blue', cursor: 'pointer', marginBottom: '2px' }}
                                                    onClick={() => openFilePreview({ url: img.url, filename: img.filename })}
                                                >
                                                    {img.filename}
                                                </a>
                                                </div>
                                            </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                })}
                                </div>
                            )}
                            </div>
                        )}
                        </div>
                );
            })}
        </div>
      </div>

      <div className="w-auto p-6 m-4 bg-gray-100">
        <form onSubmit={formik.handleSubmit}>
        {/* Stav */}
        <div className="mb-3">
            <label className="block text-md font-semibold text-gray-800">{t('Common.Status')}</label>
            <select
                name="status"
                value={formik.values.status  || ''}
                onChange={formik.handleChange} disabled
                className="w-full border rounded-md px-2 py-1 text-sm"
            >               
                <option value="OK">OK</option>
                <option value="NOK">NOK</option>
            </select>
        </div>

        {/* Stav procesu */}
        <div className="mb-3">
            <label className="block text-md font-semibold text-gray-800">{t('Common.ProcessStatus')}</label>
            <select
                name="status"
                value={formik.values.process_status  || ''}
                onChange={formik.handleChange} disabled
                className="w-full border rounded-md px-2 py-1 text-sm"
            >               
                <option value="Vytvorený">{t('Common.Created')}</option>
                <option value="Nevytvorený">{t('Common.NotCreated')}</option>
                <option value="Rozpracovaný">{t('Common.InProgress')}</option>
            </select>
        </div>
        
        {/* Vyjadrenie vedúceho */}
        <div className="mb-3">
            <label className="block text-md font-semibold text-gray-800">Vyjadrenie</label>
            <InputTextarea
                autoResize
                name="manager_response"
                value={formik.values.manager_response}
                disabled={formChecklistRecord?.process_status== 'Rozpracovaný' || user?.id!=(formChecklistRecord ?? checklist_record)?.template?.manager_id || formChecklistRecord?.checklist_status== 'Uzavretý'}
                onChange={(e) =>
                    formik.setFieldValue("manager_response", e.target.value)
                }
                className="w-full px-3 py-2 text-sm border rounded-md"
            />
        </div>

        {/* Stav vyjadrenie vedúceho */}
        <div className="mb-3">
            <label className="block text-md font-semibold text-gray-800">{t('Common.StatementStatus')}</label>
            <select
                name="manager_status"
                value={formik.values.manager_status  || ''}
                onChange={formik.handleChange}
                //disabled={formChecklistRecord?.process_status== 'Rozpracovaný'  ||  user?.id!=checklist_record?.template?.manager_id}
                disabled
                className="w-full border rounded-md px-2 py-1 text-sm"
            >
                <option value="Nový">Nový</option>
                <option value="Áno">{t('Common.Yes')}</option>
                <option value="Nie">Nie</option>
                <option value="Rozpracovaný">{t('Common.InProgress')}</option>
            </select>
        </div>

        {/* Stav checklistu */}
        <div className="mb-3">
            <label className="block text-md font-semibold text-gray-800">{t('Common.ChecklistStatus')}</label>
            <select
                name="checklist_status"
                value={formik.values.checklist_status  || ''}
                onChange={formik.handleChange}
                disabled={formChecklistRecord?.process_status== 'Rozpracovaný' || user?.id!=(formChecklistRecord ?? checklist_record)?.template?.manager_id || formChecklistRecord?.checklist_status== 'Uzavretý'}
                className="w-full border rounded-md px-2 py-1 text-sm">               
                <option value="Otvorený">{t('CrmCommunication.OverallStatus.open')}</option>
                <option value="Uzavretý">{t('ServiceTask.Status.Closed')}</option>
            </select>
        </div>
        <button type="submit" ref={submitRef} className='hidden'></button>  
        </form>
      <div className="gap-7 bg-white p-2 border rounded-md">
            <div>
                {responseFiles==null && <Skeleton height="4rem" className="mb-2"></Skeleton>}
                {responseFiles?.length>0 && <div>
                    <h2 className='text-xl'>{t('ServiceTaskDetail.Attachments')}</h2>
                    <div className='flex flex-row flex-wrap w-full h-full border border-separate border-gray-400 rounded-md bg-white mb-4'>
                        {responseFiles.map((img) => {
                            return <>
                            <div className='text-black h-auto w-52'><div className='flex flex-row p-2'>
                                <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })} className="cursor-pointer">
                                    {/\.(pdf|png|jpg|jpeg|gif|webp|bmp|svg|img)$/i.test(img.filename || '') ? (
                                        <embed src={img.url+'#page=1&view=FitH&scrollbar=0'} width="100px" height="auto" />
                                    ) : (
                                        <div className="w-[100px] h-[65px] flex items-center justify-center bg-gray-100 border rounded"><PaperClipIcon /></div>
                                    )}
                                </div>
                                    <div className='flex flex-col ml-4'>
                                    <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => openFilePreview({ url: img.url, filename: img.filename })}>{img.filename}</a>
                                    {user.role=="admin" && <button type="button" className='w-fit flex flex-row px-2 py-1 border rounded-md bg-red-900' onClick={() => deleteFiles(img)} ><DeleteIcon/></button>}
                                    </div>
                                </div>
                            </div></>;
                        })}
                    </div>
                </div>}    
            </div>     
        <div className="mb-3">
            <div className='flex justify-between'>
                <h1 className='text-xl font-semibold text-black mb-4'>Aktivita</h1>
                <button type='button' onClick={() => setSortDescending(prev => !prev)} title={sortDescending ? t('Common.SortOldestFirst') : t('Common.SortNewestFirst')} className="text-gray-600 hover:text-gray-800">
                    <i className={`pi ${sortDescending ? 'pi-sort-amount-down' : 'pi-sort-amount-up'}`}></i>
                </button>
            </div>
            <div ref={scrollRef} className='h-fit overflow-y-auto'>
            {(sortDescending && (formChecklistRecord ?? state.checklist_all_records?.find(record => record?.id == (formChecklistRecord?.id ?? resolvedId)))?.checklist_status!=="Uzavretý") && <div className='flex flex-row mb-3'>
                <div className='basis-1/10'>
                    <Avatar className='p-overlay-badge' title={user?.employee?.name || user?.username} label={getUserInitials(user?.employee?.name || user?.username)} shape="circle" style={{ backgroundColor: getUserColor(user?.username), color: '#ffffff',marginRight: '5px'}}/>
                </div>
                {(!commentClick) ? <div className='flex flex-col basis-9/10'>
                    <input 
                    type='text' onClick={() => {setCommentClick(true);}}
                    placeholder={t('Common.AddCommentPlaceholder')}
                    className='app-activity-add-comment-input px-1 py-1 border focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                    />
                </div>:
                <form onSubmit={formikComment.handleSubmit}>
                    <div className="app-activity-comment-editor-border-wrap">
                    <MyEditor editorValue={formikComment.values.description} autofocus={true} fileAccept="*" formik={formikComment} activityMessageRadius={true} />
                    </div>
                    <div className='flex flex-row gap-1'>
                        <button typye="button" onClick={() => setCommentClick(false)} className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-gray-600 rounded-md hover:bg-gray-400 focus:outline-none disabled:opacity-25'>{t('Common.Cancel')}</button>
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>
                    </div>
                    </form>}
            </div>}
            {((formChecklistRecord?.comments?.length
                ? formChecklistRecord?.comments
                : state.checklist_all_records?.find(record => record?.id == (formChecklistRecord?.id ?? resolvedId))?.comments || []
            )?.filter(c => c != null) ?? [])
            .slice()
            .sort((a, b) => {
                const aid = a?.id ?? 0;
                const bid = b?.id ?? 0;
                return sortDescending ? bid - aid : aid - bid;
            })
            .map((comment) =>
            <div key={comment?.id} className='flex flex-row w-full justify-between mb-3'>
                <div className='basis-1/10'>
                    {comment?.by_system<2 ? <Avatar className='p-overlay-badge' title={comment.contractor?.employee?.name || comment.contractor?.username} label={getUserInitials(comment.contractor?.employee?.name || comment.contractor?.username)} shape="circle" style={{ backgroundColor: getUserColor(comment.contractor.username), color: '#ffffff',marginRight: '5px'}}/>
                    :<Avatar className='p-overlay-badge' title="System" icon="pi pi-database" shape="circle" style={{ backgroundColor: 'grey', color: '#ffffff',marginRight: '5px'}}/>}

                </div>
                <div className='flex flex-col grow basis-8/10'>
                    {comment?.by_system<2 ? <div className='mb-1'><span className='font-semibold'>{comment.contractor?.employee?.name || comment.contractor?.username}</span> {formatDate(comment.updated_at, false)} o {DateTime.fromISO(comment.updated_at).toFormat("HH:mm")}</div>:
                    <div className='mb-1'><span className='font-semibold'>{t('ServiceTaskDetail.SystemNotification')}</span> {formatDate(comment.updated_at, false)} o {DateTime.fromISO(comment.updated_at).toFormat("HH:mm")}</div>}
                    {comment?.by_system==0 ? <div>{(comment?.id == lastAddedComment?.id && updatableComment) ? 
                        <form onSubmit={formikUpdateComment.handleSubmit}>
                        <div className="app-activity-comment-editor-border-wrap">
                        <MyEditor editorValue={formikUpdateComment.description} autofocus={true} fileAccept="*" formik={formikUpdateComment} activityMessageRadius={true} />
                        </div>
                        <div className='flex flex-row gap-1'>
                        <button typye="button" onClick={() => setUpdatableComment(false)} className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-gray-600 rounded-md hover:bg-gray-400 focus:outline-none disabled:opacity-25'>{t('Common.Cancel')}</button>
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none disabled:opacity-25'>{t('Common.Edit')}</button>
                        </div>
                    </form> : <MyEditor editorValue={comment.description} hideToolbar={true} hideFileUpload={true} compact={true} formik={null} activityMessageRadius={true} />}{/*parse(comment.description || "")*/}
                    </div> : <Message severity="info" content={() => content(comment?.description)} className='justify-start bg-gray-100' />}
                </div>
                {(comment?.id == lastAddedComment?.id && comment?.contractor_id == user?.id && (formChecklistRecord ?? state.checklist_all_records?.find(record => record?.id == (formChecklistRecord?.id ?? resolvedId)))?.checklist_status!=="Uzavretý" && comment?.by_system==0) && 
                <div className='flex basis-1/10'>
                    {!updatableComment && <button  onClick={(e) => op.current.toggle(e)}><i className='pi pi-ellipsis-v'></i></button>}
                    <OverlayPanel ref={op}>
                        <div className='flex flex-col'>
                            <div className='flex flex-row items-center hover:bg-gray-200'>
                                <button className='px-4 py-3' onClick={(e) => {formikUpdateComment.setFieldValue('id',comment.id);formikUpdateComment.setFieldValue('description',comment.description);setUpdatableComment(true);op.current.toggle();}}><i className='pi pi-pencil mr-2'></i><span className='font-semibold'>{t('Common.Edit')}</span></button>
                            </div>
                            {/*<div className='flex flex-row items-center p-4 pt-2 hover:bg-gray-200'>
                                <button><i className='pi pi-trash mr-2'></i><span className='font-semibold'>{t('Common.Clear')}</span></button>
                            </div>*/}
                        </div>
                    </OverlayPanel>
                </div>}
            </div>)}
            {(!sortDescending && (formChecklistRecord ?? state.checklist_all_records?.find(record => record?.id == (formChecklistRecord?.id ?? resolvedId)))?.checklist_status!=="Uzavretý" && <div className='flex flex-row mt-3'>
                <div className='basis-1/10'>
                    <Avatar className='p-overlay-badge' title={user?.employee?.name || user?.username} label={getUserInitials(user?.employee?.name || user?.username)} shape="circle" style={{ backgroundColor: getUserColor(user?.username), color: '#ffffff',marginRight: '5px'}}/>
                </div>
                {(!commentClick) ? <div className='flex flex-col basis-9/10'>
                    <input 
                    type='text' onClick={() => {setCommentClick(true);}}
                    placeholder={t('Common.AddCommentPlaceholder')}
                    className='app-activity-add-comment-input px-1 py-1 border focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                    />
                </div>:
                <form onSubmit={formikComment.handleSubmit}>
                    <div className="app-activity-comment-editor-border-wrap">
                    <MyEditor editorValue={formikComment.values.description} autofocus={true} fileAccept="*" formik={formikComment} activityMessageRadius={true} />
                    </div>
                    <div className='flex flex-row gap-1'>
                        <button typye="button" onClick={() => setCommentClick(false)} className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-gray-600 rounded-md hover:bg-gray-400 focus:outline-none disabled:opacity-25'>{t('Common.Cancel')}</button>
                        <button type="submit" className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Common.Save')}</button>
                    </div>
                    </form>}
            </div>)}
            </div>
        </div>
        <div className='flex flex-col mb-5 pt-7'><label className='font-bold mb-1'>{t('ServiceTaskDetail.InterestedUsers')}</label>
            {((formChecklistRecord ?? state.checklist_all_records?.find(record => record?.id == (formChecklistRecord?.id ?? resolvedId)))?.mentions ?? [])
            .filter(u => u != null)
            .map((mentionUser) =>
                <div key={mentionUser?.id} className='flex items-center gap-2 text-gray-800 mb-2'>
                    <Avatar className='p-overlay-badge' title={mentionUser?.employee?.name || mentionUser?.username} label={getUserInitials(mentionUser?.employee?.name || mentionUser?.username)} shape="circle" style={{ backgroundColor: getUserColor(mentionUser?.username), color: '#ffffff',marginRight: '5px'}}/>
                    <div className='flex flex-col'>
                        <span>{mentionUser?.employee?.name || mentionUser?.username}</span>
                    </div>
                </div>
            )}
            <div className='text-gray-800'>
            <button type="button" onClick={() => {setShowAddUser(true);}} className='flex items-center gap-2 disabled:opacity-25' disabled={(formChecklistRecord ?? state.checklist_all_records?.find(record => record?.id == (formChecklistRecord?.id ?? resolvedId)))?.checklist_status==="Uzavretý"}>
                <i className='pi pi-plus mr-2 px-1' style={{fontSize:"1.5rem"}}></i>Pridať používateľa
            </button>
            </div>
        </div>
        </div>  
      </div>
    </div>
    </div>
    <Dialog header={t('Common.AddUser')} visible={showAddUser} style={{ width: '70vw' }} onHide={() => {setShowAddUser(false);setAddedUser([]);}}>
        <div className='w-auto flex flex-col'>
        <MultiSelect onChange={(e) => setAddedUser(e.target.value)} value={addedUser} 
            options={(state.users?.filter(db_user => !(formChecklistRecord ?? checklist_record)?.mentions?.map(mention => mention?.id)?.includes(db_user?.id)) ?? []).map((u) =>
                ({ name: u?.employee?.name || u?.username, id: u?.id, searchLabel: removeDiacritics(u?.employee?.name || u?.username || '').toLowerCase() })
            )} 
            optionLabel="name"
            filter
            filterBy="searchLabel"
            filterMatchMode="contains"
            filterPlaceholder={t('Common.SearchShort')} placeholder={t('Common.SelectUsers')} className="w-full px-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/> 
        </div>
        <div>
        <button type="submit" disabled={addedUser==""} onClick={() => addUser()} className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none disabled:opacity-25'>{t('Common.Save')}</button>
        </div>
    </Dialog>
    </div>
    </>
    );
}